import React, { useEffect } from 'react';
import * as mobxReact from 'mobx-react';
import { BlueprintsTab, BlueprintsVM } from './blueprints.viewmodel';
import { SubWindowsHost } from '../global/sub-window/sub-windows-host';
import { FormattedMessage } from 'react-intl';
import { EventBlueprints } from './event-blueprints/event-blueprints';
import { MeetingTemplates } from './meeting-templates/meeting-templates';
import { ConnectionTemplates } from './conections-templates/connection-templates';
import { OrderTemplates } from './order-templates/order-templates';

export type BlueprintsPresentationProps = {
    vm: BlueprintsVM;
};

export const BlueprintsTabContent = (props: { activeTab: BlueprintsTab }): JSX.Element => {
    switch (props.activeTab) {
        case BlueprintsTab.EventBlueprints:
            return <EventBlueprints />;
        case BlueprintsTab.MeetingTemplates:
            return <MeetingTemplates/>;
        case BlueprintsTab.ConnectionTemplates:
            return <ConnectionTemplates/>;
        case BlueprintsTab.OrderTemplates:
            return <OrderTemplates/>;
        default:
            return null;
    }
};

export const BlueprintsPresentation = mobxReact.observer(({ vm }: BlueprintsPresentationProps): JSX.Element => {
    useEffect(() => {
        return () => vm.willUnmount();
    }, []);

    return (
         <SubWindowsHost>
            <div className='page-container'>
                <section className='horizontal-row horizontal-row--with-bottom-margin'>
                    <h1 className='text-ellipsis'>
                        <FormattedMessage id='oe.bluerptints.page.title' defaultMessage='Blueprints and Templates'/>
                    </h1>
                </section>

                <BlueprintsTabContent activeTab={vm.getActiveTab()} />
            </div>
         </SubWindowsHost>
    );
});
